<p-toast
    [style]="{ width: 'auto' }"
    [key]="'seraToastKey'"
    [preventOpenDuplicates]="true"
    position="top-center">
    <ng-template
        let-message
        #message>
        <div class="sera-toast-template">
            <i class="ci {{ message.icon }}"></i>
            <p [innerHTML]="message.summary | translate"></p>
        </div>
    </ng-template>
</p-toast>
